module.exports = __webpack_public_path__ + "static/media/banner_bottom.19da80c7.jpg";